/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-07-06 17:12:30
 * @LastEditors: linxi
 * @LastEditTime: 2025-06-25 09:32:18
 */
import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Col, Form, Modal, notification, Pagination, Row, Space, Table } from 'antd'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { RootDispatch } from '../../../app/store'
import { DateRangeType, DateSelect } from '../../../compnents/form/DateSelect'
import { EditableList } from '../../../compnents/list/EditableList'
import { DateTimeFormat } from '../../../models/datetime'
import { InventoryChangeParams } from '../../../services/InventChange'
import { InventoryChangeColumns } from '../../InventoryChange/columns'
import { chainInventoryReceiptsDetailFn, chainInventoryReceiptsReturnDetailFn, getInventoryChangePageAsync, getJumpDataByLedgerItemId, purchaseBusinessDetailFn } from '../../InventoryChange/InventoryChangSlice'
import styles from '../Storesearch.module.css'
import { PaymentResult } from '../../payment/result/PaymentResult'
import { InventoryStock } from '../../Inventorystock/InventoryStock'
import { Putstortlist } from '../../putstorelist/putstortlist'
import { ChainPutstortList } from '../../chainTransferApplication/chainTransferApplicationDetail'
import {convertObjectToURLSearchParams} from "../../../app/applicationSlice";
import { getCheckPermissionAsync } from '../../FunctionSetting/dataPermission/dataPermissionSlice'
import { SJQXChecks } from '../../../models/dataPersion'
import { selectSettings } from '../../user/setting/settingSlice'

export const ChangeWasteBook = () => {
  const dispatch = useDispatch<RootDispatch>()

  const settings = useSelector(selectSettings)

  const [form] = Form.useForm()

  const location: any = useLocation()

  const [size, setSize] = useState(5)

  const [total, setTotal] = useState(0)

  const [current, setCurrent] = useState(1)

  const [data, setData] = useState<any>([])

  const [totalData, setTotalData] = useState<any>()

  const [queries, setQueries] = useState<InventoryChangeParams>({
    createTimeStart: moment().startOf('day').format(DateTimeFormat),
    createTimeEnd: moment().endOf('day').format(DateTimeFormat),
  })

  const [pageLoading, setPageLoading] = useState(false) //表格 loading

  const [rowData, setRowData] = useState<any>({});

  const [dataDetail, setDataDetail] = useState<any>({});

  const [visibleCategory, setVisibleCategory] = useState(false);

  const [KFGZZCKLRSJData, setKFGZZCKLRSJData] = useState<any>(true)

  useEffect(() => {
    setTotalData(data?.[0])
  }, [data])

  // 库房工作站查看利润数据权限
  useEffect(() => {
     if (!location?.state?.flag) {
       dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.KFGZZCKLRSJ }))
         .then(unwrapResult)
         .then((res: any) => {
           setKFGZZCKLRSJData(res)
         })
     }else{
       setKFGZZCKLRSJData(true)
     }
  }, [location?.state?.flag])

  useEffect(() => {
    if (location) {
      setPageLoading(true)
      const params = convertObjectToURLSearchParams({
        size,
        current,
        tenantInventoryLedgerId: location.state.selectId,
        ...queries,
      });
      dispatch(
        getInventoryChangePageAsync(params)
      )
        .then(unwrapResult)
        .then((res: any) => {
          setData(res.outInvItemPages.records)
          setTotal(res.outInvItemPages.total)
        })
        .finally(() => setPageLoading(false))
    }
  }, [size, current, queries])

  return (
    <>
      <Form
        form={form}
        name='control-hooks'
        autoComplete='off'
        onFinish={(vs) => {
          setQueries({
            createTimeEnd: vs.registrationTimeTail,
            createTimeStart: vs.registrationTimeHead,
          })
        }}
      >
        <Row
          style={{
            margin: '10px 0',
          }}
          justify='space-between'
        >
          <Space>
            <Form.Item name='' noStyle>
              <DateSelect
                placeholder='时间范围'
                style={{ width: '8rem' }}
                onChange={form.submit}
                labelPrefix=''
                initialValue={DateRangeType.Today}
                namePrefix='registrationTime'
              />
            </Form.Item>
            <Button type='primary' htmlType='submit'>
              查询
            </Button>
          </Space>
        </Row>
      </Form>
      <div className={styles.detailTable}>
        <EditableList
          style={{ height: '100%' }}
          loading={pageLoading}
          columns={InventoryChangeColumns(size * (current - 1), (t: any) => {
            if (t?.category === '11' || t?.category === '12') {
              dispatch(
                getJumpDataByLedgerItemId({
                  tenantInventoryLedgerItemId: t?.tenantInventoryLedgerItemId,
                })
              )
                .then(unwrapResult)
                .then((res: any) => {
                  if (!res?.isDeleted) {
                    setRowData({ ...t, ...res })
                    setVisibleCategory(true)
                  } else {
                    notification.error({
                      message: '该记录已被删除',
                      duration: 3,
                    })
                  }
                })
            } else if (t?.category === '201' || t?.category === '202') {
              dispatch(
                chainInventoryReceiptsDetailFn({
                  inventoryReceiptsId: t?.tenantInventoryReceiptsId,
                })
              )
                .then(unwrapResult)
                .then((res: any) => {
                  setRowData(t)
                  setDataDetail(res)
                  setVisibleCategory(true)
                })
            } else if (t?.category === '203') {
              dispatch(
                purchaseBusinessDetailFn({
                  inventoryReceiptsId: t?.tenantInventoryReceiptsId,
                  category: t?.category,
                })
              )
                .then(unwrapResult)
                .then((res: any) => {
                  setRowData(t)
                  setDataDetail(res)
                  setVisibleCategory(true)
                })
            } else if (t?.category === '205' || t?.category === '206') {
              dispatch(
                chainInventoryReceiptsReturnDetailFn({
                  inventoryReceiptsId: t?.tenantInventoryReceiptsId,
                })
              )
                .then(unwrapResult)
                .then((res: any) => {
                  setRowData(t)
                  setDataDetail(res)
                  setVisibleCategory(true)
                })
            } else {
              setRowData({ ...t })
              setVisibleCategory(true)
            }
          },'', '', '', '', KFGZZCKLRSJData, settings)}
          pagination={false}
          bordered
          page={{
            items: data,
            current,
            size: size,
            total,
          }}
        />
        <Pagination
          total={total}
          current={current}
          pageSize={size}
          showSizeChanger
          showQuickJumper
          pageSizeOptions={['5', '10', '15', '20']}
          style={{
            position: 'absolute',
            bottom: '30px',
            right: '40px',
          }}
          showTotal={(total) => `共 ${total} 条`}
          onChange={(current, size) => {
            setSize(size as number)
            setCurrent(current)
          }}
        />
      </div>

      <Modal
        visible={visibleCategory}
        width={'85vw'}
        onOk={() => {
          setVisibleCategory(false)
        }}
        onCancel={() => {
          setVisibleCategory(false)
        }}
        footer={null}
        destroyOnClose
      >
        <div
          style={{
            maxHeight: '80vh',
            overflow: 'auto',
            paddingBottom: rowData?.category === '8' ? '40px' : '0px',
          }}
        >
          {rowData?.category === '11' || rowData?.category === '12' ? (
            <PaymentResult currentPaymentId={rowData?.paymentId} />
          ) : rowData?.category === '8' ? (
            <InventoryStock
              category={rowData?.category}
              selectId={rowData?.tenantInventoryReceiptsId}
            />
          ) : rowData?.category == '201' ||
            rowData?.category == '202' ||
            rowData?.category == '203' ||
            rowData?.category == '205' ||
            rowData?.category == '206' ? (
            <ChainPutstortList
              category={rowData?.category}
              selectId={rowData?.tenantInventoryReceiptsId}
              detail={dataDetail}
            />
          ) : (
            <Putstortlist
              putNumber={rowData?.putNumber}
              category={rowData?.category}
              selectId={rowData?.tenantInventoryReceiptsId}
            />
          )}
        </div>
      </Modal>
    </>
  )
}
